import { useAuthentication } from '@zenbusiness/application-commons-authentication';
import { gql, useManualQuery } from '@zenbusiness/application-commons-graphql';

import useFlowState from './flow/useFlowState';

const SHOULD_LOGIN_QUERY = gql`
  query shouldLogin($email: String!) {
    shouldLogin(email: $email)
  }
`;

/**
 * Hook to check if the user should be prompted to log in based in their email address.
 * @returns {Function} A function that takes an email address and returns a boolean.
 */
export default function useShouldPromptLogin() {
  const { authenticated } = useAuthentication();
  const [checkShouldLogin] = useManualQuery(SHOULD_LOGIN_QUERY);
  const { businessInfo } = useFlowState();

  return async (email) => {
    // If the user is authenticated, we should not prompt them to log in
    if (authenticated) {
      return false;
    }

    // If we already have an accountUuid in flow state, we should not prompt to log in
    if (businessInfo?.accountUuid) {
      return false;
    }

    // Otherwise, we should check if the user should log in based on their email
    const {
      data: { shouldLogin }
    } = await checkShouldLogin({ variables: { email } });

    return shouldLogin;
  };
}
